import { format, isBefore } from "date-fns";
import { Table, OptionsDataType, ColDataType, RowDataType } from "@thrivetribe/mvf.ui.organisms.table";
import { ClubStats as ClubStatsProp } from "types/Legacy/ClubStats";
import "../empty-table.scss";
import "./Fixtures.scss";

const columns: ColDataType[] = [
  { id: "leftCol", label: "", align: "center" },
  { id: "middleCol", label: "", align: "center" },
  { id: "rightCol", label: "", align: "center" },
];

interface CustomRowDataType extends RowDataType {
  leftCol?: string;
  middleCol?: JSX.Element;
  rightCol?: string;
}

interface FixturesProps {
  title: string;
  stats: ClubStatsProp["ListLeagueFixtures"] | ClubStatsProp["ListLeagueCupFixtures"] | undefined;
}

export const Fixtures = ({ title, stats }: FixturesProps): JSX.Element => {
  const options: OptionsDataType = {
    tableAriaLabel: title,
    tablePrefixClass: "club-fixtures",
    headerSticky: true,
    headerEl: <h2>{title}</h2>,
    headerColTitlesDisabled: true,
  };

  const upcomingLeagueFixtures = stats ?? [];
  const fixturesInPast: boolean[] = [];

  const rows: CustomRowDataType[][] = upcomingLeagueFixtures.map((leagueFixture) => {
    const leagueFixtureDateTimeStr = leagueFixture.FixtureDateTime?.replaceAll(/Date|\/|\(|\)/g, "");
    const leagueFixtureLocalDateTime = new Date(Number(leagueFixtureDateTimeStr));
    const serverLeagueFixtureDateTime = new Date(
      leagueFixtureLocalDateTime.getUTCFullYear(),
      leagueFixtureLocalDateTime.getUTCMonth(),
      leagueFixtureLocalDateTime.getUTCDate(),
      leagueFixtureLocalDateTime.getUTCHours(),
      leagueFixtureLocalDateTime.getUTCMinutes(),
      leagueFixtureLocalDateTime.getUTCSeconds()
    );

    if (leagueFixtureDateTimeStr !== undefined && isBefore(serverLeagueFixtureDateTime, new Date())) {
      fixturesInPast.push(true);
      return [{}];
    } else {
      fixturesInPast.push(false);
    }

    const fixtureHeaderRow: CustomRowDataType = {
      middleCol: <time dateTime={leagueFixture.FixtureDate_Str}>{leagueFixture.FixtureDate_Str}</time>,
      options: {
        className: "table__body__row--subtitle",
        colSpan: 3,
      },
    };

    const fixtureBodyRows: CustomRowDataType[] = leagueFixture.ListOfFixtures.map((fixture) => {
      const fixtureDateTimeStr = fixture.FixtureDateTime?.replaceAll(/Date|\/|\(|\)/g, "");
      const fixtureLocalDateTime = new Date(Number(fixtureDateTimeStr));
      const serverFixtureDateTime = new Date(
        fixtureLocalDateTime.getUTCFullYear(),
        fixtureLocalDateTime.getUTCMonth(),
        fixtureLocalDateTime.getUTCDate(),
        fixtureLocalDateTime.getUTCHours(),
        fixtureLocalDateTime.getUTCMinutes(),
        fixtureLocalDateTime.getUTCSeconds()
      );
      const time = format(serverFixtureDateTime, "HH:mm");

      return {
        leftCol: fixture.HomeTeamName,
        middleCol: (
          <div className="vs">
            <span>vs</span>
            <span>{time}</span>
          </div>
        ),
        rightCol: fixture.AwayTeamName,
        options: {
          hoverDisabled: true,
        },
      };
    });

    return [fixtureHeaderRow, ...fixtureBodyRows];
  });

  if (upcomingLeagueFixtures.length === 0 || !fixturesInPast.includes(false)) {
    return (
      <article className="club-fixtures-container">
        <section className="empty-table">
          <div className="empty-table__heading">
            <h2>{title}</h2>
          </div>
          <div className="empty-table__content">
            <span>Looks like no more games are coming up this season</span>
          </div>
        </section>
      </article>
    );
  }

  return (
    <article className="club-fixtures-container">
      <Table<CustomRowDataType> options={options} columns={columns} rows={rows} />
    </article>
  );
};
